// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f36616fe","991":"8d21ebca"}[chunkId] + ".chunk.js";
};